import type { ITranslationObject } from "@krea/shared/types/common";

import en from "./en.json";
import fi from "./fi.json";
import sv from "./sv.json";

export const loanWidgetTranslations: ITranslationObject<typeof en> = {
  en,
  sv,
  fi,
  namespace: "loanWidget",
};

export interface ILoanWidgetTranslations {
  loanWidget: (typeof loanWidgetTranslations)["en"];
}
